const messages = {
  title: "O BS Plus",
  description: "About page description",
};

export default {
  messages,
};
